<template>
  <v-container>
    <v-row align="center">
      <v-col cols="12" md="12">
        <v-skeleton-loader
          class="mx-auto"
          type="image, card-heading, list-item-three-line, divider, card-heading, list-item-three-line, list-item-three-line, actions"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class LoaderReport extends Vue {}
</script>

<style scoped></style>
